<template>
  <div class="vehicle-list-card-wrapper">
    <div class="vehicle-list-card">
      <div class="vehicle-list-card-top">
        <img
          :src="vehicle.image"
          :alt="vehicle.name"
          class="vehicle-list-card-image"
        />
        <div class="vehicle-list-card-title">
          <strong>{{ vehicle.name }}</strong>
          <p class="mb-0 text-muted">{{ vehicle.category }}</p>
        </div>
        <div class="vehicle-list-card-actions">
          <button
            type="button"
            class="vehicle-list-card-action"
            title="Ver veículo"
            @click.stop="$emit('view', vehicle)"
          >
            <i class="no no-view"></i>
          </button>
          <button
            type="button"
            class="vehicle-list-card-action"
            title="Editar registro"
            disabled
          >
            <i class="fas fa-pen"></i>
          </button>
        </div>
      </div>

      <div class="vehicle-list-card-row">
        <strong>Combustível:</strong>
        <span v-if="vehicle.fuelName" class="vehicle-list-fuel">
          <i :class="fuelIconClass" aria-hidden="true"></i>
          {{ vehicle.fuelName }}
        </span>
        <span v-else class="text-muted">—</span>
      </div>
      <div class="vehicle-list-card-row">
        <strong>Placa:</strong>
        <span>{{ vehicle.plate }}</span>
      </div>
      <div class="vehicle-list-card-row">
        <strong>Capacidade:</strong>
        <span>{{ capacityLabel }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VehicleListCard',

  props: {
    vehicle: {
      type: Object,
      required: true,
    },
  },

  computed: {
    capacityLabel() {
      const count = Number(this.vehicle.capacity) || 0
      return count === 1 ? '1 pessoa' : `${count} pessoas`
    },

    fuelIconClass() {
      return String(this.vehicle.fuelIcon || '').replace(/\bfa-solid\b/g, 'fas')
    },
  },
}
</script>

<style>
.vehicle-list-card-wrapper {
  margin: 0 0.75rem 0.75rem;
  border: 1px solid #e8eef1;
  border-radius: 8px;
  background: #fff;
}

.vehicle-list-card {
  padding: 0.85rem;
}

.vehicle-list-card-top {
  display: flex;
  align-items: flex-start;
  gap: 0.65rem;
  margin-bottom: 0.65rem;
}

.vehicle-list-card-image {
  width: 56px;
  height: 56px;
  object-fit: cover;
  border-radius: 6px;
  background: #f3f4f6;
  flex-shrink: 0;
}

.vehicle-list-card-title {
  min-width: 0;
  flex: 1;
}

.vehicle-list-card-actions {
  display: flex;
  gap: 0.35rem;
}

.vehicle-list-card-action {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  border: 0;
  border-radius: 6px;
  background: #eef5f8;
  color: #12576e;
  cursor: pointer;
}

.vehicle-list-card-action:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.vehicle-list-card-row {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  font-size: 0.9rem;
  color: #3b4654;
}

.vehicle-list-card .vehicle-list-fuel {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
}

.vehicle-list-card .vehicle-list-fuel i {
  color: #12576e;
}
</style>
